import qs from 'qs';

import { client } from '../client';
import { UserProfile, UserRoleName } from './types/UserProfile';

export interface IListUsers {
  nodes: UserProfile[];
  total: number;
}

export interface IListUsersParams {
  limit?: number;
  full_name?: string;
  email?: string;
  external_id?: string;
  id?: string;
  status?: string[];
  type?: UserRoleName[];
  organization_ids?: string[];
  client_tags?: string[];
  client_division_ids?: number[];
  network?: string[];
  skip?: number;
  page?: number;
  state?: string;
  sort_by?:
    | 'full_name'
    | 'email'
    | 'external_id'
    | 'id'
    | 'status'
    | 'type'
    | 'organization_ids'
    | 'client_tags'
    | 'state'
    | 'network';
  sort_direction?: 'asc' | 'desc';
  cursor?: string;
  cursor_direction?: 'next' | 'previous';
  date_of_birth_start?: string;
  date_of_birth_end?: string;
}

export const listAllUsers = async (params?: IListUsersParams, signal?: AbortSignal): Promise<IListUsers> => {
  const { data } = await client.get<IListUsers>(
    `/admin/users?${qs.stringify(params, { skipNulls: true, arrayFormat: 'repeat' })}`,
    { signal },
  );

  return data;
};
